import { render, staticRenderFns } from "./animation.vue?vue&type=template&id=1079ab82&scoped=true&"
import script from "./animation.vue?vue&type=script&lang=js&"
export * from "./animation.vue?vue&type=script&lang=js&"
import style0 from "./animation.vue?vue&type=style&index=0&id=1079ab82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079ab82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1079ab82')) {
      api.createRecord('1079ab82', component.options)
    } else {
      api.reload('1079ab82', component.options)
    }
    module.hot.accept("./animation.vue?vue&type=template&id=1079ab82&scoped=true&", function () {
      api.rerender('1079ab82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/upgrade/detail/components/animation.vue"
export default component.exports